// extracted by mini-css-extract-plugin
export default {"solution_area":"Solution_solution_area__K70xY","contents":"Solution_contents__t6AHK","vanta":"Solution_vanta__HSFuc"};